import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { BasicObjectSMI, Consejo } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class ConsejoService {

  private controlador = computed(() => 'consejo');
  private api = new ConsumirApi(this.controlador());

  constructor() {}

  public obtenerTodos(idPregunta:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idPregunta}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idPregunta}`);
  }

  public obtenerPorId(idPregunta:number, id: number): Observable<Consejo>{
    return from(this.api.get<Consejo>(`${idPregunta}/${id}`));
    // return this.http.get<consejoDTO>(`${this.apiURL}/${idPregunta}/${id}`);
  }

  public crear(registro:Consejo){
    return from(this.api.post<Consejo,boolean>(``, registro));
    // return this.http.post(this.apiURL, registro);
  }

  public validarNombre(registro:Consejo){
    return from(this.api.post<Consejo,boolean>(`validarNombre`, registro));
    // return this.http.post(`${this.apiURL}/validarNombre`, registro);
  }

  public editar(id: number, registro:Consejo){
    return from(this.api.put<Consejo,boolean>(`${id}`, registro));
    // return this.http.put(`${this.apiURL}/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}
